import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  Colors,
  DataStore,
  FontSizes,
  FontFamilies,
  Logger,
  Theme,
  isValidEmail,
  formatPhoneNumber,
  formatPhoneNumberDisplay,
  isValidPhoneNumber,
  isValidProviderResult
} from 'common';

import {
  Button,
  Checkbox,
  OtpInput,
  Stepper,
  Text,
  TextInput,
} from 'common/components';

import {
  withCommon
} from 'common/hocs';

import {
  HtmlModal
} from 'ui/components';

import {
  EventName,
  MaxWidthContainer,
  StepperContainer,
} from 'ui/event/styled';

import {
  AuthProvider
} from 'providers';

import { getCheckoutSteps, needsCustomFieldsStep } from 'ui/event/eventUtils';

const isOesenvlamfeesHost =
  typeof window !== 'undefined' &&
  window.location.hostname.includes('oesenvlamfees');

const Divide = styled.div`
  background-color: ${Theme.EventIdentity.DividerColor};
  height: 1px;
  width: 100%;
`;

const TermsContainer = styled.div`
  justify-content: center;
  padding: 20px;
  max-width: 325px;
  margin: 0 auto;
  text-align: center;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0 0 0;
`;

const ButtonSpace = styled.div`
  width: 20px;
`;

const FullWidthContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const DeliveryMethodContainer = styled.div`
  display: flex;
  margin: 0 0 15px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${Theme.EventIdentity.DividerColor};
`;

const ToggleButton = styled.button`
  flex: 1;
  padding: 12px 16px;
  border: none;
  background-color: ${(props) =>
    props.selected
      ? Colors.PrimaryOne
      : isOesenvlamfeesHost
        ? Colors.Transparent
        : Colors.White} !important;
  color: ${(props) => (props.selected ? Colors.White : isOesenvlamfeesHost? Colors.White : Colors.Black)} !important;
  font-size: ${FontSizes.Small};
  font-family: ${FontFamilies.Regular};
  cursor: pointer;
  transition: all 0.2s ease;
  border-right: ${(props) =>
    props.isLast ? 'none' : `1px solid ${Theme.EventIdentity.DividerColor}`};

  &:hover {
    background-color: ${(props) =>
      props.selected
        ? Colors.PrimaryOne
        : isOesenvlamfeesHost
          ? Colors.Transparent
          : Colors.White};
  }

  &:focus {
    outline: none;
  }
`;

const EventTicketIdentityUI = props => {

  // Authentication methods configuration
  const AUTH_CONFIG = {
    email: true,      // Enable/disable email authentication
    whatsapp: !window.location.hostname.includes('etiquetteacademysa'),   // Enable/disable WhatsApp authentication
  };

  // Get available authentication methods
  const getAvailableMethods = () => {
    const methods = [];
    if (AUTH_CONFIG.email) methods.push('email');
    if (AUTH_CONFIG.whatsapp) methods.push('whatsapp');
    return methods;
  };

  // Get the default delivery method based on config
  const getDefaultDeliveryMethod = () => {
    const availableMethods = getAvailableMethods();
    if (availableMethods.length === 0) {
      console.warn('No authentication methods enabled in AUTH_CONFIG');
      return 'email'; // fallback
    }
    return availableMethods[0]; // Use the first available method as default
  };

  // Get dynamic instruction text based on enabled methods
  const getInstructionText = () => {
    const availableMethods = getAvailableMethods();
    
    if (availableMethods.length === 0) {
      return 'You will receive a 4 digit code to verify your contact.';
    }
    
    if (availableMethods.length === 1) {
      if (availableMethods[0] === 'email') {
        return 'You will receive a 4 digit code to verify your email.';
      } else {
        return 'You will receive a 4 digit code to verify your WhatsApp number.';
      }
    }
    
    // Both methods enabled
    return 'You will receive a 4 digit code to verify your email or WhatsApp number.';
  };

  const getIntoText = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const instruction = queryParams.get('instruction');
    
    if (instruction === 'products') {
      return '';
    }
    
    return 'Tickets will be linked and sent to the below contact. ';
  };

  const getLoggedInText = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const instruction = queryParams.get('instruction');
    
    if (instruction === 'products') {
      return 'To use a different contact, please use the "Change Contact" option.';
    }
    
    return 'To have your tickets linked and sent to a different contact, please use the "Change Contact" option.';
  };

  const content = {
    email: {
      header: 'Verify Contact',
      description: '',
      instruction: getIntoText() + getInstructionText(),
      button_text: 'Submit'
    },
    otp: {
      header: 'Enter OTP',
      description: '',
      instruction: 'We sent a 4 digit code to',
      button_text: 'Submit'
    },
    logged_in: {
      header: 'Verify Contact',
      description: '',
      instruction: getIntoText() + getLoggedInText(),
      button_text: 'Continue'
    }
  };

  const [state, setState] = React.useState({
    currentView: DataStore.get('LOGGED_IN_EMAIL') && DataStore.get('ACCESS_TOKEN') ? 'logged_in' : 'email',
    email: '',
    phone: '',
    otp: '',
    deliveryMethod: getDefaultDeliveryMethod(),
    event: DataStore.get('selectedEvent') || {},
    ...(DataStore.get('LOGGED_IN_EMAIL') && DataStore.get('ACCESS_TOKEN') ? content.logged_in : content.email),
  });

  const [showTsAndCs, setShowTsAndCs] = React.useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = React.useState(false);
  const [showOrganizerTerms, setShowOrganizerTerms] = React.useState(false);
  const [showOrganizerPrivacyPolicy, setShowOrganizerPrivacyPolicy] = React.useState(false);
  const [receiveMarketing, setReceiveMarketing] = React.useState(true);
  const [showMarketingCheckbox, setShowMarketingCheckbox] = React.useState(false);
  const [otpTimeLeft, setOtpTimeLeft] = React.useState(0);
  const otpRef = React.useRef(null);

  const onEmailChange = (val) => {
    setState(prevState => ({
      ...prevState,
      email: val?.trim()
    }));
  };

  const onPhoneChange = (val) => {
    let formatted = formatPhoneNumberDisplay(val);
    setState(prevState => ({
      ...prevState,
      phone: formatted
    }));
  };

  const onDeliveryMethodChange = (method) => {
    // Only allow changing to enabled methods
    const availableMethods = getAvailableMethods();
    if (!availableMethods.includes(method)) {
      console.warn(`Authentication method '${method}' is not enabled in AUTH_CONFIG`);
      return;
    }
    
    setState(prevState => ({
      ...prevState,
      deliveryMethod: method
    }));
  };

  const onOTPChange = (val) => {
    setState(prevState => ({
      ...prevState,
      otp: val
    }));
  };

  const onResendOtpClick = () => {
    setOtpTimeLeft(30);

    AuthProvider.resendCode(DataStore.get('verifyGuid'))
        .then(ret => {
          if (!isValidProviderResult(ret)) {
            Logger.error('EventTicketIdentity', 'onResendOtpClick', ret);
            return;
          }
        })
        .catch(e => {
          Logger.error('EventTicketIdentity', 'onResendOtpClick', e);
          props.common.showToast('Oh no, something went wrong, please try again.');
        });
  };

  const validateContactInfo = () => {
    if (state.deliveryMethod === 'email') {
      if (!isValidEmail(state.email)) {
        props.common.showToast('Please enter a valid email and try again.');
        return false;
      }
      return true;
    } else if (state.deliveryMethod === 'whatsapp') {
      if (!isValidPhoneNumber(state.phone)) {
        props.common.showToast('Please enter a valid phone number and try again.');
        return false;
      }
      return true;
    }
    return false;
  };

  const getContactValue = () => {
    return state.deliveryMethod === 'email' ? state.email : state.phone;
  };

  const getContactDisplay = () => {
    const contact = getContactValue();
    if (state.deliveryMethod === 'whatsapp') {
      return `WhatsApp: ${formatPhoneNumberDisplay(contact)}`;
    }
    return contact;
  };

  const navigateAfterContactVerified = () => {
    if (state.event.has_seating && needsCustomFieldsStep(state.event, DataStore.get('selectedTickets'))) {
      props.common.navigate('/event/custom-fields');
      return;
    }

    if (state.event.has_seating) {
      const expiryTime = new Date(Date.now() + 10 * 60 * 1000).getTime();
      props.common.navigate(`/event/seats?expiry=${expiryTime}`);
      return;
    }

    if (needsCustomFieldsStep(state.event, DataStore.get('selectedTickets'))) {
      props.common.navigate('/event/custom-fields');
      return;
    }

    props.common.navigate('/event/payment');
  };

  const onSubmitClick = () => {

    if (state.currentView === 'email') {

      if (!validateContactInfo()) {
        return;
      }

      props.common.showLoading();

      const contact = state.deliveryMethod === 'email' ? state.email : formatPhoneNumber(state.phone);
      // API call to send OTP
      AuthProvider.requestCode(contact)
        .then(ret => {

          props.common.hideLoading();

          if (!isValidProviderResult(ret)) {

            props.common.showToast('Oh no, we weren\'t able to send your OTP, please check your contact details and try again.');
            return;
          }

          DataStore.set('verifyGuid', ret.data.guid);

          if (!ret.data.existingUser) {
            setShowMarketingCheckbox(true);
          }

          setState(prevState => ({
            ...prevState,
            ...content.otp,
            instruction: <div style={{ textAlign: 'center' }}>{content.otp.instruction}<br/><span style={{ fontFamily: FontFamilies.Bold}}>{getContactDisplay()}</span></div>,
            currentView: 'otp'
          }));
        })
        .catch(e => {

          Logger.error('EventTicketIdentity', 'requestCode', e);

          props.common.showToast('Oh no, something went wrong, please try again.');

          props.common.hideLoading();
        });
    }

    if (state.currentView === 'otp') {

      if (state.otp.length !== 4) {

        const deliveryText = state.deliveryMethod === 'whatsapp' ? 'WhatsApp' : 'email';
        props.common.showToast(`Please enter the 4 digit OTP sent to your ${deliveryText}.`);
        return;
      }

      props.common.showLoading();

      AuthProvider.submitCode(DataStore.get('verifyGuid'), state.otp, showMarketingCheckbox && receiveMarketing)
        .then(ret => {

          props.common.hideLoading();

          if (!isValidProviderResult(ret)) {

            props.common.showToast('Oh no, we weren\'t able to verify your OTP, please try again.');
            return;
          }

          if (!ret.data.verified) {

            if (otpRef.current) {
              otpRef.current.clear();
            }

            props.common.showToast('Incorrect OTP.  Please check your OTP and try again.');
            return;
          }

          // Store the contact info based on delivery method
          DataStore.set('ACCESS_TOKEN', ret.data.token);
          if (state.deliveryMethod === 'email') {
            DataStore.set('LOGGED_IN_EMAIL', state.email);
          } else {
            // For WhatsApp, we still need an email for tickets, so use phone as identifier
            DataStore.set('LOGGED_IN_EMAIL', state.phone);
          }

          navigateAfterContactVerified();
      })
      .catch(e => {

        Logger.error('EventTicketIdentity', 'submitCode', e);

        props.common.showToast('Oh no, something went wrong, please try again.');

        props.common.hideLoading();
      });
    }

    if (state.currentView === 'logged_in') {

      navigateAfterContactVerified();
    }
  };

  const onBackClick = () => {

    if (state.currentView === 'otp') {

      setState(prevState => ({
        ...prevState,
        ...content.email,
        currentView: 'email'
      }));

      return;
    }

    props.common.history.goBack();
  };

  React.useEffect(() => {
    if (otpTimeLeft === 0) return; // Stop the timer when it reaches 0

    const timerId = setInterval(() => {
      setOtpTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId); // Clean up the interval on unmount
  }, [otpTimeLeft]);

  React.useEffect(() => {
    EventTicketIdentityUI.timestamp = new Date().getTime();
  }, []);

  const organiserTerms = window.location.hostname.includes('oesenvlamfees')
    ? 'https://oesenvlamfees.co.za/terms.html?v=' + EventTicketIdentityUI.timestamp
    : window.location.hostname.includes('bolandrugby')
      ? 'https://storage.googleapis.com/website777/weTicket/boland_rugby/legal/TermsandConditions.html?v=' + EventTicketIdentityUI.timestamp
      : state.event.id === 1000199
        ? 'https://storage.googleapis.com/ticketing-files/websites/stroperdans/Stroperdans_Terms_and_Conditions.html?v=' + EventTicketIdentityUI.timestamp
        : '';

  const organiserPrivacyPolicy = window.location.hostname.includes('bolandrugby')
    ? 'https://storage.googleapis.com/website777/weTicket/boland_rugby/legal/PrivacyPolicy.html?v=' + EventTicketIdentityUI.timestamp
    : '';

  return (
    <>
    <Text
      maxWidth={'1100px'}
      margin={'0 auto'}
      width={'100%'}
      display={'block'} 
      padding={'20px 15px 0 15px'} 
      fontSize={FontSizes.Small}
      color={Theme.Text.Color}
    >
      <span style={{cursor: 'pointer'}} onClick={() => props.common.navigate(-1)}>← Back</span>
    </Text>

    <EventName>{state.event.name}</EventName>

    <Text display={'block'} padding={'0 15px 5px 15px'} textAlign={'center'} fontSize={FontSizes.Small}>{state.event.location_display}</Text>

    { !state.event.is_multi_event &&
      <Text display={'block'} padding={'0 15px 20px 15px'} textAlign={'center'} fontSize={FontSizes.Small}>{state.event.displayDate}</Text>
    }

    { state.event.is_multi_event &&
      <Text display={'block'} padding={'0 0 30px 0'} textAlign={'center'} fontSize={FontSizes.Small}></Text>
    }

    <FullWidthContainer>

      <StepperContainer>

        <Stepper
          items={getCheckoutSteps(state.event)}
          selectedIndex={1}
        />

      </StepperContainer>

      <MaxWidthContainer>

        <Text
          display={'block'}
          fontFamily={FontFamilies.Bold}
          fontSize={FontSizes.Big}>
            {state.header}
        </Text>

        <Text
          display={'block'}
          fontSize={FontSizes.Smaller}
          padding={'0 0 15px 0'}>
            {state.description}
        </Text>

        <Divide/>

        <Text
          display={'block'}
          fontSize={FontSizes.Smaller}
          padding={'15px 0 15px 0'}>
            {state.instruction}
        </Text>

        { state.currentView === 'email' &&
        
          <>
            {/* Only show delivery method selection if multiple methods are available */}
            {getAvailableMethods().length > 1 && (
              <DeliveryMethodContainer>
                {AUTH_CONFIG.email && (
                  <ToggleButton 
                    selected={state.deliveryMethod === 'email'} 
                    onClick={() => onDeliveryMethodChange('email')}
                    isLast={!AUTH_CONFIG.whatsapp}
                  >
                    Email
                  </ToggleButton>
                )}
                
                {AUTH_CONFIG.whatsapp && (
                  <ToggleButton 
                    selected={state.deliveryMethod === 'whatsapp'} 
                    onClick={() => onDeliveryMethodChange('whatsapp')}
                    isLast={true}
                  >
                    WhatsApp
                  </ToggleButton>
                )}
              </DeliveryMethodContainer>
            )}

            {(state.deliveryMethod === 'email' && AUTH_CONFIG.email) && (
              <TextInput
                type={'email'}
                placeholder={'Email address...'}
                width={'100%'}
                value={state.email}
                onChange={onEmailChange}
              />
            )}

            {(state.deliveryMethod === 'whatsapp' && AUTH_CONFIG.whatsapp) && (
              <TextInput
                type={'tel'}
                placeholder={'WhatsApp number...'}
                width={'100%'}
                value={state.phone}
                onChange={onPhoneChange}
              />
            )}
          </>
        }

        { state.currentView === 'otp' &&
          <>
          <OtpInput
            ref={otpRef} 
            onChange={onOTPChange}
          />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
            { otpTimeLeft > 0 && 
              <>
              <Text fontSize={FontSizes.Smaller}>Your OTP is on the way!</Text>
              <Text fontSize={FontSizes.Smaller} textAlign={'center'}>You can resend in {otpTimeLeft} seconds.</Text>
              </>
            }
            { otpTimeLeft <= 0 && <Text textDecoration={'underline'} fontSize={FontSizes.Smaller} onClick={onResendOtpClick}>Resend OTP</Text> }
          </div>
          </>
        }

        { state.currentView === 'logged_in' &&
        
          <>
          <Text fontFamily={FontFamilies.Bold}>{DataStore.get('LOGGED_IN_EMAIL')?.includes('@') ? DataStore.get('LOGGED_IN_EMAIL') : formatPhoneNumberDisplay(DataStore.get('LOGGED_IN_EMAIL'))}</Text>
          <Button
            backgroundColor={Colors.Transparent}
            border={Theme.EventIdentity.ButtonBorder}
            textColor={Theme.EventIdentity.ButtonTextColor}
            fontFamily={FontFamilies.Regular}
            fontSize={FontSizes.Smaller}
            margin={'15px 0 0 0'}
            text={"Change Contact"}
            width={'125px'}
            onClick={() => setState(prevState => ({
              ...prevState,
              ...content.email,
              currentView: 'email'
            }))}
          />
          </>

        }
      </MaxWidthContainer>

      <div style={{ flex: 1, minHeight: props.common.isWidget ? '30px' : 'auto' }} />

      <MaxWidthContainer padding={'0'}>

        <ActionContainer>

          <MaxWidthContainer>

          { (state.currentView === 'email' || state.currentView === 'logged_in') &&

            <TermsContainer>

              <Text fontSize={FontSizes.Smaller}>
                {window.location.hostname.includes('bolandrugby') && <>By clicking submit you agree to our <Text onClick={() => setShowOrganizerTerms(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Organizer Terms</Text>, <Text onClick={() => setShowOrganizerPrivacyPolicy(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Organizer Privacy Policy</Text>, <Text onClick={() => setShowTsAndCs(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Terms of Use</Text> and <Text onClick={() => setShowPrivacyPolicy(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Privacy Policy</Text></>}
                {window.location.hostname.includes('oesenvlamfees') && <>By clicking submit you agree to our <Text onClick={() => setShowOrganizerTerms(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Organizer Terms</Text>, <Text onClick={() => setShowTsAndCs(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Terms of Use</Text> and <Text onClick={() => setShowPrivacyPolicy(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Privacy Policy</Text></>}
                {state.event.id === 1000199 && <>By clicking submit you agree to our <Text onClick={() => setShowOrganizerTerms(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Organizer Terms</Text>, <Text onClick={() => setShowTsAndCs(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Terms of Use</Text> and <Text onClick={() => setShowPrivacyPolicy(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Privacy Policy</Text></>}
                {!window.location.hostname.includes('oesenvlamfees') && !window.location.hostname.includes('bolandrugby') && state.event.id !== 1000199 && <>By clicking submit you agree to our <Text onClick={() => setShowTsAndCs(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Terms of Use</Text> and <Text onClick={() => setShowPrivacyPolicy(true)} fontSize={FontSizes.Smaller} fontFamily={FontFamilies.Bold}>Privacy Policy</Text></>}
              </Text>

            </TermsContainer>
          }

          { state.currentView === 'otp' && showMarketingCheckbox &&

            <Checkbox
              defaultChecked={receiveMarketing}
              padding={'15px 0 15px 2px'}
              label={'Stay in the loop! Tick this box if you would like to hear about upcoming events.'}
              onClick={(checked) => setReceiveMarketing(checked)}
            />
          }

          <Divide/>

          <ActionButtonContainer>

            <Button onClick={onBackClick} backgroundColor={Theme.Button.Secondary.Background}>Back</Button>

            <ButtonSpace/>

            <Button onClick={onSubmitClick}>{state.button_text}</Button>

          </ActionButtonContainer>

          </MaxWidthContainer>

        </ActionContainer>

      </MaxWidthContainer>

    </FullWidthContainer>

    <HtmlModal url={'https://storage.googleapis.com/website777/weTicket/diazSummerSplash/weticket_terms.html?v=' + EventTicketIdentityUI.timestamp} show={showTsAndCs} onClose={() => setShowTsAndCs(false)}/>
    <HtmlModal url={'https://storage.googleapis.com/website777/weTicket/diazSummerSplash/weticket_privacy_policy.html?v=' + EventTicketIdentityUI.timestamp} show={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)}/>
    <HtmlModal url={organiserTerms} show={showOrganizerTerms} onClose={() => setShowOrganizerTerms(false)}/>
    <HtmlModal url={organiserPrivacyPolicy} show={showOrganizerPrivacyPolicy} onClose={() => setShowOrganizerPrivacyPolicy(false)}/>

    </>
  );
};

export const EventTicketIdentity = withCommon(
  EventTicketIdentityUI, {
    showLoadingOnLoad: false
  }
);